export default __webpack_public_path__ + "static/media/08-1.f6eb7b8c.jpg";